import { GetProp, UploadFile, UploadProps } from 'antd';
import { RcFile } from 'antd/es/upload';
import { IDocument } from 'app/modules/Financial/types';
import type { UploadFileStatus } from 'antd/es/upload/interface';

export type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

export const getBase64Image = (file: FileType | File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export type UploadEvent =
  | {
      fileList?: UploadFile[];
    }
  | UploadFile[];

export const getFile = (e: UploadEvent): UploadFile[] | undefined => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

export const getProfilePictureFileList = (picture: string): UploadFile[] => {
  const imageName = decodeURIComponent(picture.split('/').at(-1)?.split('?')[0] ?? 'profile-image');
  return [
    {
      uid: '-1',
      name: imageName,
      status: 'done',
      url: picture,
      type: 'image/jpeg',
    },
  ];
};

export type FileWithOrigin = {
  originFileObj?: File;
}[];

export const appendFileIfExists = (formData: FormData, key: string, file: FileWithOrigin): void => {
  if (file?.[0]?.originFileObj) {
    const fileName = file?.[0]?.originFileObj?.name?.replace(/\s+/g, '_').replace(/[^a-zA-Z._-]/g, '');

    const tranformedFile = new File([file?.[0]?.originFileObj], fileName, {
      type: file?.[0]?.originFileObj?.type,
    });

    formData.append(key, tranformedFile);
  }
};

export const transformFile = (file: RcFile | File): File => {
  const fileName = file?.name?.replace(/\s+/g, '_').replace(/[^a-zA-Z._-]/g, '');

  return new File([file], fileName, { type: file?.type });
};

export const mapInvoicesToFileList = (docs: IDocument[]): UploadFile[] => {
  return docs.map((doc) => ({
    uid: doc.documentId?.toString() ?? '',
    name: doc.fileUrl.split('/').pop() || 'file',
    status: 'done' as UploadFileStatus,
    url: doc.fileUrl,
    type: 'image/png',
  }));
};
